import { ApolloLink } from '@apollo/client';

// Exports
type Options = { headers?: Record<string, string> };
/** Use to set request headers globally on all queries */
export const setHeadersMiddleware = ({ headers = {} }: Options) => {
  const filteredHeaders = Object.fromEntries(
    Object.entries(headers).filter(([, value]) => !!value),
  );

  return new ApolloLink((operation, forward) => {
    const context = operation.getContext();
    operation.setContext({
      ...context,
      headers: { ...context.headers, ...filteredHeaders },
    });
    return forward(operation);
  });
};
